import {useState} from "react";
import {useVehiclesInspectedQuery} from "./hooks/useVehiclesInspectedQuery.js"
import PDFInspeccionVehiculos from "../../common/components/PDFInspeccionVehiculos.jsx"
import Textfield from "../../common/components/Textfiled.jsx"

function CopyFormatsUsed(){
  const [filters, setFilteres] = useState({
    initialDate: "",
    finalDate: "",
    page: 1
  })
  const {vehiclesInspected} = useVehiclesInspectedQuery(filters)

  const handleChangeFilters = ({name, value}) => {
    setFilteres((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

    return(
    <main className="container">
      <header className="text-center">
        <h1 className="fs-1">Copias de formatos utilizados para la inspección</h1>
      </header>
      <section className="d-flex flex-column gap-4">
        <div className="d-flex justify-content-around gap-3">
            <Textfield label="Fecha Inicial" name="initialDate" type="date" value={filters.initialDate} onChange={handleChangeFilters}/>
            <Textfield label="Fecha Final" name="finalDate" type="date" value={filters.finalDate} onChange={handleChangeFilters}/>
        </div>

        {vehiclesInspected.length > 0 ? (
          <PDFInspeccionVehiculos encuestas={vehiclesInspected} />
                  ) : (
          
<div class="alert alert-info text-center my-4" role="alert">
  No hay datos disponibles
</div>
        )}
      </section>
      </main>
    )
  }

export default CopyFormatsUsed;
